/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var ElevationHelper = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ElevationHelper, _super);
    function ElevationHelper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ElevationHelper.g = function (a, b) {
        if (ElevationHelper.c == null) {
            ElevationHelper.c = ["0 1px 3px 0 ", "0 1px 5px 0 ", "0 1px 8px 0 ", "0 2px 4px -1px ", "0 3px 5px -1px ", "0 3px 5px -1px ", "0 4px 5px -2px ", "0 5px 5px -3px ", "0 5px 6px -3px ", "0 6px 6px -3px ", "0 6px 7px -4px ", "0 7px 8px -4px ", "0 7px 8px -4px ", "0 7px 9px -4px ", "0 8px 9px -5px ", "0 8px 10px -5px ", "0 8px 11px -5px ", "0 9px 11px -5px ", "0 9px 12px -6px ", "0 10px 13px -6px ", "0 10px 13px -6px ", "0 10px 14px -6px ", "0 11px 14px -7px ", "0 11px 15px -7px "];
        }
        a--;
        if (a < 0) {
            return "";
        }
        if (a > ElevationHelper.c.length - 1) {
            a = ElevationHelper.c.length - 1;
        }
        return ElevationHelper.c[a] + b;
    };
    ElevationHelper.f = function (a, b) {
        if (ElevationHelper.b == null) {
            ElevationHelper.b = ["0 1px 1px 0 ", "0 2px 2px 0 ", "0 3px 4px 0 ", "0 4px 5px 0 ", "0 5px 8px 0 ", "0 6px 10px 0 ", "0 7px 10px 1px ", "0 8px 10px 1px ", "0 9px 12px 1px ", "0 10px 14px 1px ", "0 11px 15px 1px ", "0 12px 17px 2px ", "0 13px 19px 2px ", "0 14px 21px 2px ", "0 15px 22px 2px ", "0 16px 24px 2px ", "0 17px 26px 2px ", "0 18px 28px 2px ", "0 19px 29px 2px ", "0 20px 31px 3px ", "0 21px 33px 3px ", "0 22px 35px 3px ", "0 23px 36px 3px ", "0 24px 38px 3px "];
        }
        a--;
        if (a < 0) {
            return "";
        }
        if (a > ElevationHelper.b.length - 1) {
            a = ElevationHelper.b.length - 1;
        }
        return ElevationHelper.b[a] + b;
    };
    ElevationHelper.d = function (a, b) {
        if (ElevationHelper.a == null) {
            ElevationHelper.a = ["0 2px 1px -1px ", "0 3px 1px -2px ", "0 3px 3px -2px ", "0 1px 10px 0 ", "0 1px 14px 0 ", "0 1px 18px 0 ", "0 2px 16px 1px ", "0 3px 14px 2px ", "0 3px 16px 2px ", "0 4px 18px 3px ", "0 4px 20px 3px ", "0 5px 22px 4px ", "0 5px 24px 4px ", "0 5px 26px 4px ", "0 6px 28px 5px ", "0 6px 30px 5px ", "0 6px 32px 5px ", "0 7px 34px 6px ", "0 7px 36px 6px ", "0 8px 38px 7px ", "0 8px 40px 7px ", "0 8px 42px 7px ", "0 9px 44px 8px ", "0 9px 46px 8px "];
        }
        a--;
        if (a < 0) {
            return "";
        }
        if (a > ElevationHelper.a.length - 1) {
            a = ElevationHelper.a.length - 1;
        }
        return ElevationHelper.a[a] + b;
    };
    ElevationHelper.e = function (a, b, c, d) {
        if (a == 0) {
            return "";
        }
        return ElevationHelper.g(a, b._fill) + ", " + ElevationHelper.f(a, c._fill) + ", " + ElevationHelper.d(a, d._fill);
    };
    ElevationHelper.$t = markType(ElevationHelper, 'ElevationHelper');
    ElevationHelper.c = null;
    ElevationHelper.b = null;
    ElevationHelper.a = null;
    return ElevationHelper;
}(Base));
export { ElevationHelper };
//# sourceMappingURL=ElevationHelper.js.map
